import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { useRemoveProjectExpense } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectExpenseRemoval({ cancel, projectExpense }: Props) {
  const { t } = useTranslation();
  const { removeProjectExpense, isRequestPending } =
    useRemoveProjectExpense(projectExpense);

  return (
    <Modal
      header={t("projectBudgetSynthesis.expenses.removal.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("projectBudgetSynthesis.expenses.removal.confirmation")}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("projectBudgetSynthesis.expenses.removal.cancel")}
          </Button>
          <Button
            type={"delete"}
            status={isRequestPending ? "pending" : "none"}
            press={() => removeProjectExpense(projectExpense)}
          >
            {t("projectBudgetSynthesis.expenses.removal.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ProjectExpenseRemoval };
